export enum RequestPaths {
  ChooseCourt = 'choose-court',
  CourtSystem = 'court-system',
  Courthouse = 'courthouse',
  Courtroom = 'courtroom',
  Department = 'department',
  Recordings = 'recordings',
  Transcripts = 'transcripts',
}

export enum RequestParams {
  RequestType = 'requestType',
  CourtSystemId = 'courtSystemId',
  CourthouseId = 'courthouseId',
  CourtroomId = 'courtroomId',
  DepartmentId = 'departmentId',
}
